export default __webpack_public_path__ + "static/media/Adidas.10f7028c.png";